import React, { useEffect, useMemo, useState } from "react";
import styles from "./ModalSettings.module.scss";
import { Input, Modal, ImageLoader } from "../../components";
import { useDispatch, useSelector } from "react-redux";

import { notifyError, notifyInfo } from "../../utils/notify";

import { editUserInfo } from "../../store/slices/user/asyncThunks";
import { selectEditUserInfoPending } from "../../store/slices/user/slice";

const ModalSettings = ({ modalRef, userDetails }) => {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const editUserInfoPending = useSelector(selectEditUserInfoPending);

  useEffect(() => {
    if (userDetails) {
      setFirstName(userDetails.firstName);
      setLastName(userDetails.lastName);
      setEmail(userDetails.email);
    }
  }, [userDetails]);

  const btnDisabled = useMemo(() => {
    return (
      (oldPassword.trim().length && oldPassword.trim().length < 6) ||
      (oldPassword.trim().length && !newPassword.trim().length) ||
      (newPassword.trim().length && newPassword.trim().length < 6)
    );
  }, [oldPassword, newPassword]);

  const confirm = () => {
    if (newPassword !== confirmPassword) {
      notifyError("New password not match");
    } else {
      dispatch(
        editUserInfo({
          firstName,
          lastName,
          imageFile: profilePhoto,
          oldPassword,
          newPassword,
        })
      ).then((promise) => {
        if (promise.type.includes("fulfilled")) {
          notifyInfo("Successfully edited data");
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          notifyError(promise.error.message);
        }
      });
    }
  };

  return (
    <Modal
      ref={modalRef}
      title="Settings"
      buttonOkText="CONFIRM"
      buttonCloseText="CANCEL"
      buttonOkOnClick={confirm}
      buttonCloseOnClick={() => modalRef.current.hide()}
      onClose={() => modalRef.current.hide()}
      pendingAction={editUserInfoPending}
      buttonOkDisabled={btnDisabled}
    >
      <div style={{ flexDirection: "column", gap: 20, display: "flex" }}>
        <ImageLoader
          user={{
            firstName: firstName,
            lastName: lastName,
            profilePhoto: userDetails?.profilePhoto,
          }}
          textUploadImage={"Change Photo"}
          flexColumn={true}
          setImageFile={setProfilePhoto}
        ></ImageLoader>
        <Input
          placeholder="First Name"
          onChange={(event) => setFirstName(event)}
          value={firstName}
        ></Input>
        <Input
          placeholder="Last Name"
          onChange={(event) => setLastName(event)}
          value={lastName}
        ></Input>
        <Input
          placeholder="Email"
          onChange={(event) => setEmail(event)}
          disabled
          value={email}
        ></Input>

        <h2 className={styles.modalH2}>Change Password</h2>
        <Input
          placeholder="Old Password"
          onChange={(event) => setOldPassword(event)}
          value={oldPassword}
          type="password"
        ></Input>
        <Input
          placeholder="New Password"
          type="password"
          onChange={(event) => setNewPassword(event)}
          value={newPassword}
        ></Input>
        <Input
          placeholder="Confirm Password"
          type="password"
          onChange={(event) => setConfirmPassword(event)}
          value={confirmPassword}
        ></Input>
      </div>
    </Modal>
  );
};

export default ModalSettings;
